// extracted by mini-css-extract-plugin
export var container = "_9h-0";
export var fallback = "_9h-5";
export var fallbackIcon = "_9h-6";
export var hidden = "_9h-2";
export var image = "_9h-3";
export var loaded = "_9h-4";
export var placeholder = "_9h-1";